module.exports = __webpack_public_path__ + "static/presspops-9f37b95faf3281b0b0f7af685490760b.svg";